// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

import type { DatabaseReservation } from './reservartiontypes';
import type { DatabaseEpicEngage } from './epicengagetypes';
import type { DatabaseEpicEngagev1 } from './epicengagev1types';

const REACT_APP_SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL; 
const REACT_APP_SUPABASE_PUBLISHABLE_KEY = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(REACT_APP_SUPABASE_URL, REACT_APP_SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});


const REACT_APP_EMAIL_SUPABASE_URL = process.env.REACT_APP_EMAIL_SUPABASE_URL; 
const REACT_APP_EMAIL_SUPABASE_PUBLISHABLE_KEY = process.env.REACT_APP_EMAIL_SUPABASE_PUBLISHABLE_KEY;

// Import the supabase client like this:
export const epicengageSupabase = createClient<DatabaseEpicEngage>(REACT_APP_EMAIL_SUPABASE_URL, REACT_APP_EMAIL_SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});


const REACT_APP_ENGAGEV1_SUPABASE_URL = process.env.REACT_APP_SUPABASE_ENGAGEV1_URL; 
const REACT_APP_ENGAGEV1_SUPABASE_PUBLISHABLE_KEY = process.env.REACT_APP_SUPABASE_ENGAGEV1_PUBLISHABLE_KEY;

// Import the supabase client like this:
export const epicengageSupabasev1 = createClient<DatabaseEpicEngagev1>(REACT_APP_ENGAGEV1_SUPABASE_URL, REACT_APP_ENGAGEV1_SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});


const REACT_APP_RESERVATION_SUPABASE_URL = process.env.REACT_APP_RESERVATION_SUPABASE_URL; 
const REACT_APP_RESERVATION_SUPABASE_PUBLISHABLE_KEY = process.env.REACT_APP_RESERVATION_SUPABASE_PUBLISHABLE_KEY;
// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabaseReservation = createClient<DatabaseReservation>(REACT_APP_RESERVATION_SUPABASE_URL, REACT_APP_RESERVATION_SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});
